import training1 from './img/training1.png';
import training2 from './img/training2.png';
import training3 from './img/training3.png';

export default [
  {
    textId: 'trainingText1',
    titleId: 'trainingTitle1',
    icon: training1,
  },
  {
    textId: 'trainingText2',
    titleId: 'trainingTitle2',
    icon: training2,
  },
  {
    textId: 'trainingText3',
    titleId: 'trainingTitle3',
    icon: training3,
  }
]